import { ComponentProps, FC, forwardRef } from 'react'
import { styled } from '../../config'

const SliderInput = styled('input', {
  appearance: 'none',
  width: '100%',
  height: '3px',
  borderRadius: '5px',
  backgroundColor: '#FFFFFF33',
  outline: 'none',
  transition: 'opacity .2s',
  '&::-webkit-slider-thumb': {
    '-webkit-appearance': 'none',
    appearance: 'none',
    width: '6px',
    height: '6px',
    background: '$gray0200',
    borderRadius: '50%',
    border: 'none',
    alignSelf: 'center',
    transition: 'transform 100ms ease'
  },
  '&::-webkit-slider-thumb:hover': {
    transform: 'scale(1.3)',
    cursor: 'pointer'
  },
  '&::-webkit-slider-thumb:active': {
    transform: 'scale(1)'
  },
  variants: {
    hideThumb: {
      true: {
        '&::-webkit-slider-thumb': {
          width: '2px',
          height: '2px'
        },
        '&:hover::-webkit-slider-thumb': {
          transform: 'scale(4)',
          cursor: 'pointer'
        }
      }
    }
  }
})

export const Slider: FC<ComponentProps<typeof SliderInput>> = forwardRef(
  ({ type, ...props }, ref) => {
    const { value, min, max } = {
      value: Number(props.value || 0),
      min: Number(props.min || 0),
      max: Number(props.max || 100)
    }
    const rangePercentage = ((value - min) / (max - min)) * 100

    return (
      <SliderInput
        css={{
          backgroundImage: `linear-gradient(90deg, #FFFFFF ${rangePercentage}%, transparent ${rangePercentage}%)`
        }}
        type="range"
        ref={ref}
        {...props}
      />
    )
  }
)
